/* eslint-disable react/no-unescaped-entities */
import { useRouter } from 'next/router';
import { useTranslation } from 'react-i18next';
import Footer from '@buddieshr/components/footer';
import Header from '@buddieshr/components/header';
import MetaHeader from '@buddieshr/components/metaHeader';
import styles from '@buddieshr/styles/legalNotice.module.scss';
import PageWrapper from '@buddieshr/components/templates/pageWrapper';

export default function LegalNotice() {
  const router = useRouter();
  const { t } = useTranslation();

  return (
    <>
      <MetaHeader
        title={'Legal Notice and Company Information | BuddiesHR'}
        description={
          "Find Legal information, address and VAT-ID from BuddiesHR's company."
        }
        currentURL={`https://buddieshr.com/${
          router.locale === 'en' ? '' : router.locale
        }/legal-notice`}
        currentShare="https://buddieshr.com/img/share_preview_1.png"
        pageSlug="legal-notice"
        locale={router.locale}
      />
      <Header />
      <main className={styles.main}>
        <div className={styles.headerWrapper}>
          <PageWrapper width={800}>
            <h1 className={styles.bold}>Legal Notice</h1>
            <p>Find important information about BuddiesHR's company.</p>
          </PageWrapper>
        </div>
        <PageWrapper width={800}>
          <div className={styles.Page_inner}>
            <div>
              <h2>Company</h2>
              <div className={styles.legalElement}>
                <div className={styles.legalTitle}>Name:</div>
                <div className={styles.legalContent}>The Jeffrey Company</div>
              </div>
              <div className={styles.legalElement}>
                <div className={styles.legalTitle}>Legal Status:</div>
                <div className={styles.legalContent}>SAS</div>
              </div>
              <div className={styles.legalElement}>
                <div className={styles.legalTitle}>Registration:</div>
                <div className={styles.legalContent}>
                  RCS Paris B 838 465 581
                </div>
              </div>
              <div className={styles.legalElement}>
                <div className={styles.legalTitle}>SIRET:</div>
                <div className={styles.legalContent}>83846558100034</div>
              </div>
              <div className={styles.legalElement}>
                <div className={styles.legalTitle}>Address:</div>
                <div className={styles.legalContent}>
                  102 AVENUE DES CHAMPS ELYSEES, 75008 PARIS France
                </div>
              </div>
              <div className={styles.legalElement}>
                <div className={styles.legalTitle}>Intracommunity VAT-ID:</div>
                <div className={styles.legalContent}>FR30838465581</div>
              </div>
              <div className={styles.legalElement}>
                <div className={styles.legalTitle}>Contact Email:</div>
                <div className={styles.legalContent}>hey@buddieshr.com</div>
              </div>
            </div>
          </div>
        </PageWrapper>
      </main>
      <Footer />
    </>
  );
}
